// @flow
import _has from "lodash/has";
import _isPlainObject from "lodash/isPlainObject";

/**
 */
const isPlainObject = (value: any): boolean => _isPlainObject(value);

/**
 */
const has = (obj: any, propName: string): boolean => {
  if (!isPlainObject(obj)) {
    return false;
  }

  return _has(obj, propName);
};

/**
 * Retrieve property of an object
 * When path is only one deep better use optional chaining
 */
const get = (obj: Object, path: string, defaultValue?: any): any =>
  String(path)
    .split(".")
    .reduce((acc, v) => {
      if (typeof acc === "object") {
        return acc[v] ?? defaultValue;
      }
      return defaultValue;
    }, obj);

export { get, has, isPlainObject };
